import _ from 'lodash';
import {
  FETCH_USER_IMPC_SELECTIONS_SUCCESS,
  SAVE_USER_IMPC_SELECTION_REQUEST,
  DELETE_USER_IMPC_SELECTION_REQUEST,
  FETCH_USER_OPERATOR_SELECTIONS_SUCCESS,
  SAVE_USER_OPERATOR_SELECTION_REQUEST,
  DELETE_USER_OPERATOR_SELECTION_REQUEST,
} from '../../../../user/redux/actions/types/UserActionTypes';
import { ENTERED_WIZARD } from '../../../common/redux/actions/types/SelectionCriteriaWizardActionTypes';
import postalOperatorsMapper from '../mappers/postalOperatorsMapper';
import {
  ARRIVAL_MAIL_PROCESSING_CENTER_CHECKED,
  ARRIVAL_POSTAL_OPERATOR_EXPANDED,
  DESELECT_ALL_ARRIVAL_MAIL_PROCESSING_CENTERS,
  RETRIEVE_INBOUND_POSTAL_OPERATOR_REQUEST,
  RETRIEVE_INBOUND_POSTAL_OPERATOR_SUCCESS,
  RETRIEVE_INBOUND_POSTAL_OPERATOR_FAILURE,
  SELECT_ALL_ARRIVAL_MAIL_PROCESSING_CENTERS,
  SELECT_ALL_ARRIVAL_OPERATORS,
  DESELECT_ALL_ARRIVAL_OPERATORS,
} from '../actions/types/ArrivalPostalOperatorActionTypes';
import filterIMPCCodesIfExistsInPostalOperators from '../filters/filterIMPCCodesIfExistsInPostalOperators';
import { SWITCH_DEPARTURE_ARRIVAL } from '../actions/types/PostalOperatorActionTypes';
import OperatorTypes from '../../../../common/redux/actions/types/OperatorTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';
import operatorsMapper from '../mappers/operatorsMapper';
import filterOperatorCodesIfExistsInPostalOperators from '../filters/filterOperatorCodesIfExistsInPostalOperators';
import {
  DELETE_GLOBAL_SELECTION_IMPC_REQUEST,
  SAVE_GLOBAL_SELECTION_IMPC_REQUEST,
} from '../../../../admin/dashboard/redux/actions/types/AdminDashboardActionTypes';

export const initialState = {
  nodes: [],
  nodesForOperator: [],
  checkedMailProcessingCenters: [],
  checkedOperator: [],
  expandedPostalOperators: [],
  selections: [],
  isLoading: false,
};

const allChildNodeValues = nodes =>
  nodes.map(node => node.children.map(mPC => mPC.value))
    .reduce((initial, impcCodes) => initial.concat(impcCodes));

const handleUserIMPCSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, { name: action.payload.selectionName });
  const newSelection = {
    name: action.payload.selectionName,
    direction: null,
    impcCodes: action.payload.selectedIMPCCodes,
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));

  return {
    ...state,
    selections,
  };
};

const handleAdminIMPCSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, { name: action.payload.selectionName });
  const newSelection = {
    name: action.payload.selectionName,
    direction: null,
    impcCodes: action.payload.selectedIMPCCodes,
    scope: 'GLOBAL',
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));

  return {
    ...state,
    selections,
  };
};

const handleUserOperatorSelectionRequest = (action, state) => {
  const selections = [...state.selections];
  const indexOfExistingSelection = _.findIndex(selections, { name: action.payload.selectionName });
  const newSelection = {
    name: action.payload.selectionName,
    direction: null,
    operatorCodes: action.payload.selectedIMPCCodes,
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleUserIMPCSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter(item => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleAdminIMPCSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter(item => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

export const arrivalPostalOperatorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_IMPC_SELECTIONS_SUCCESS:
      if (action.payload.postalOperatorType === OperatorTypes.ARRIVAL) {
        return {
          ...state,
          selections: [...action.payload.selections]
            .map(selection => ({
              ...selection,
              name: selection.name === 'LAST_SELECTION' ? 'Your last selection' : selection.name,
            }))
            .sort((a, b) => a.name.localeCompare(b.name)),
        };
      }
      return state;
    case FETCH_USER_OPERATOR_SELECTIONS_SUCCESS:
      if (action.payload.postalOperatorType === OperatorTypes.ARRIVAL) {
        return {
          ...state,
          selections: [...action.payload.selections]
            .map(selection => ({
              ...selection,
              name: selection.name === 'LAST_SELECTION' ? 'Your last selection' : selection.name,
            }))
            .sort((a, b) => a.name.localeCompare(b.name)),
        };
      }
      return state;
    case RETRIEVE_INBOUND_POSTAL_OPERATOR_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case RETRIEVE_INBOUND_POSTAL_OPERATOR_SUCCESS:
      return {
        ...state,
        nodes: postalOperatorsMapper(action.payload),
        nodesForOperator: operatorsMapper(action.payload),
        isLoading: false,
      };
    case RETRIEVE_INBOUND_POSTAL_OPERATOR_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case ARRIVAL_MAIL_PROCESSING_CENTER_CHECKED:
      return {
        ...state,
        checkedMailProcessingCenters: filterIMPCCodesIfExistsInPostalOperators(
          action.checkedMailProcessingCenters,
          state.nodes,
          action.reportDefinition,
        ),
        checkedOperator: filterOperatorCodesIfExistsInPostalOperators(
          action.checkedMailProcessingCenters,
          state.nodesForOperator,
        ),
      };
    case ARRIVAL_POSTAL_OPERATOR_EXPANDED:
      return {
        ...state,
        expandedPostalOperators: [...action.expandedPostalOperators],
      };
    case SELECT_ALL_ARRIVAL_MAIL_PROCESSING_CENTERS:
      return {
        ...state,
        checkedMailProcessingCenters: allChildNodeValues(action.payload.nodes),
      };
    case SELECT_ALL_ARRIVAL_OPERATORS:
      return {
        ...state,
        checkedOperator: action.payload.nodes.map(node => node.value),
      };
    case DESELECT_ALL_ARRIVAL_MAIL_PROCESSING_CENTERS:
      return {
        ...state,
        checkedMailProcessingCenters: [],
      };
    case DESELECT_ALL_ARRIVAL_OPERATORS:
      return {
        ...state,
        checkedOperator: [],
      };
    case ENTERED_WIZARD:
      return initialState;
    case SAVE_USER_IMPC_SELECTION_REQUEST:
      return handleUserIMPCSelectionRequest(action, state);
    case SAVE_USER_OPERATOR_SELECTION_REQUEST:
      return handleUserOperatorSelectionRequest(action, state);
    case SAVE_GLOBAL_SELECTION_IMPC_REQUEST:
      return handleAdminIMPCSelectionRequest(action, state);
    case DELETE_USER_IMPC_SELECTION_REQUEST:
      return handleUserIMPCSelectionDeleteRequest(action, state);
    case DELETE_USER_OPERATOR_SELECTION_REQUEST:
      return handleUserIMPCSelectionDeleteRequest(action, state);
    case DELETE_GLOBAL_SELECTION_IMPC_REQUEST:
      return handleAdminIMPCSelectionDeleteRequest(action, state);
    case SWITCH_DEPARTURE_ARRIVAL:
      return {
        ...state,
        ...action.payload.departure,
      };
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};

